import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import '../../settings.scss';
import { newObjectCreater } from '../../../../../utils/controller';
import { getCities, getIndustries, getStates } from '../../../../../services/vendor';
import ProfileForm from './components/profileForm';
import {
	getOrganizationProfile,
	updateProfileSettings,
} from '../../../../../services/settings/organization';
import PageLoader from '../../../../../component/PageLoader';
import SettingHeaderComponent from '../../components/settingHeaderComponent';
import { useDispatch } from 'react-redux';
import { fetchUserInfo } from '../../../../../store/action/userInfo';
import { validateGSTNumber, validDrugLicenseNumber } from '../../../../../utils/utility';
import { getDate } from '../../../../../utils/dateUtils';

export default function ProfileSettings({ activeTab }) {
	const dispatch = useDispatch();
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [loader, setLoader] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [cityList, setCityList] = useState([]);
	const [stateList, setStatesList] = useState([]);
	const [industryList, setIndustrieList] = useState([]);
	const [languageList, setLanguageList] = useState([{ key: 'English', value: 'English' }]);
	const [fiscalYearList, setFiscalYearList] = useState([
		{ key: 'April-March', value: 'April-March' },
	]);
	const [dateFormatList, setDateFormatList] = useState([]);
	const [dateSeparatorList, setDateSeparatorList] = useState([
		{ key: '/', value: '/' },
		{ key: '-', value: '-' },
		{ key: '.', value: '.' },
	]);
	const [timeZoneList, setTimeZoneList] = useState([
		{ key: 'India(GMT+5:30)', value: 'India(GMT+5:30)' },
	]);
	const [primaryContact, setPrimaryContact] = useState({ name: '', email: '', phone_number: '' });
	const [primaryContactForm, setPrimaryContactForm] = useState({
		name: '',
		email: '',
		phone_number: '',
	});
	const [organisationProfile, setOrganisationProfile] = useState({});
	const [formData, setFormData] = useState({
		organisation_name: '',
		organisation_logo: null,
		industry_name: '',
		address: {
			street_1: '',
			street_2: '',
			state_id: '',
			city_id: '',
			postal_code: '',
			country_id: 1,
			phone_number: '',
		},
		domain: '',
		fiscal_year: '',
		language: '',
		time_zone: '',
		date_format: '',
		date_separator: '',
		drug_license_number: '',
		gst_settings: {
			gst_registration_enable: false,
			gstin: '',
			business_legal_name: '',
			business_trade_name: '',
			gst_registration_date: '',
			composition_enable: false,
			composition_scheme: false,
		},
	});
	const [error, setError] = useState({});

	const handleFormData = (key, value, required = false) => {
		setFormData((prev) => ({
			...prev,
			[key]: value,
		}));
		let newError = { ...error };
		if (key === 'drug_license_number') {
			if (value && !validDrugLicenseNumber(value)) {
				newError.drug_license_number = 'Please enter valid drug license number';
			} else {
				delete newError.drug_license_number;
			}
		}
		if (required) {
			if (key === 'industry_id') {
				if (value === '') {
					newError.industry_id = 'Please select a valid industry from the list.';
				} else {
					delete newError.industry_id;
				}
			}
			if (key === 'organisation_name') {
				if (value === '' || value === null) {
					newError.organisation_name = 'Please enter organization name in the field.';
				} else {
					delete newError.organisation_name;
				}
			}
			if (key === 'domain') {
				if (value === '' || value === null) {
					newError.domain = 'Please enter organization domain in the field.';
				} else {
					delete newError.domain;
				}
			}
		}
		setError(newError);
	};

	const handleGSTFormData = (key, value) => {
		setFormData((prev) => ({
			...prev,
			gst_settings: {
				...prev.gst_settings,
				[key]: value,
			},
		}));
		let newError = { ...error };
		if (key === 'gstin') {
			if (!value || value === '') {
				newError.gstin = 'Please enter gstin number in the field';
			} else if (!validateGSTNumber(value)) {
				newError.gstin = 'Please enter valid gstin number in the field';
			} else {
				delete newError.gstin;
			}
		}
		if (key === 'business_legal_name') {
			if (!value || value === '') {
				newError.business_legal_name = 'Please enter business legal name in the field';
			} else {
				delete newError.business_legal_name;
			}
		}
		if (key === 'business_trade_name') {
			if (!value || value === '') {
				newError.business_trade_name = 'Please enter business trade name in the field';
			} else {
				delete newError.business_trade_name;
			}
		}
		if (key === 'gst_registration_date') {
			if (!value || value === '') {
				newError.gst_registration_date = 'Please enter gst registration date in the field';
			} else {
				var date = new Date(value);
				var currentDate = new Date();
				currentDate.setDate(currentDate.getDate() + 1);
				let year = date.getFullYear().toString();
				if (year.length === 4 && new Date(value) > currentDate.setHours(0, 0, 0, 0)) {
					newError.gst_registration_date = 'Date cannot be in the future';
				} else {
					delete newError.gst_registration_date;
				}
			}
		}
		setError(newError);
	};

	const handleAddressFormData = (key, value, required = false) => {
		setFormData((prev) => ({
			...prev,
			address: {
				...prev.address,
				[key]: value,
			},
		}));
		if (required) {
			var newError = { ...error };
			if (key === 'phone_number') {
				if (value) {
					if (value.length > 10 || value.length < 10) {
						newError.phone_number = `Please enter valid mobile number in the field`;
					} else {
						delete newError.phone_number;
					}
				} else {
					delete newError.phone_number;
				}
			}
			setError(newError);
		}
	};
	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}


	async function getOrganizationProfileDetail() {
		try {
			setLoading(true);
			const { organisation, address, primary_contact, gst_settings } = await getOrganizationProfile();
			var organisationDetails = {
				organisation_name: organisation?.organisation_name,
				organisation_logo:
					organisation?.organisation_logo !== undefined && organisation?.organisation_logo !== null
						? organisation?.organisation_logo
						: '',
				industry_id: organisation?.industry?.id || '',
				address: {
					street_1: address?.street_1 || '',
					street_2: address?.street_2 || '',
					state_id: address?.state?.id,
					city_id: address?.city?.id,
					postal_code: address?.postal_code,
					country_id: address?.country?.id,
					phone_number: organisation?.phone_number || '',
				},
				domain: organisation?.sub_domain || '',
				fiscal_year: organisation?.fiscal_year,
				language: organisation?.language,
				time_zone: organisation?.time_zone,
				date_format:
					organisation?.date_format !== undefined && organisation?.date_format !== null
						? organisation?.date_format
						: '',
				date_separator:
					organisation?.date_separator !== undefined && organisation?.date_separator !== null
						? organisation?.date_separator
						: '',
				drug_license_number: organisation?.drug_license_number || '',
				gst_settings: {
					gst_registration_enable: gst_settings?.gst_registration_enable || false,
					gstin: gst_settings?.gstin || '',
					business_legal_name: gst_settings?.business_legal_name || '',
					business_trade_name: gst_settings?.business_trade_name || '',
					gst_registration_date: gst_settings?.gst_registration_date
						? getDate(gst_settings.gst_registration_date, true)
						: '',
					composition_enable: gst_settings?.composition_enable || false,
					composition_scheme: gst_settings?.composition_scheme || false,
				},
			};
			var contactDetail = {
				name: `${primary_contact?.first_name || ''} ${primary_contact?.last_name || ''}`,
				email: primary_contact?.email || '',
				phone_number: primary_contact?.phone_number || '',
			};
			setFormData(organisationDetails);
			setPrimaryContact(contactDetail);
			setOrganisationProfile(organisationDetails);
			setError({});
		} catch (err) {
			toast.error(err.message || 'Something went wrong!');
		} finally {
			setLoading(false);
		}
	}

	function checkValidation() {
		const newError = { ...error };
		if (
			!formData.industry_id ||
			formData.industry_id === '' ||
			formData.industry_id === undefined
		) {
			newError.industry_id = 'Please select a valid industry from the list.';
		} else {
			delete newError.industry_id;
		}
		if (
			!formData.organisation_name ||
			formData.organisation_name === '' ||
			formData.organisation_name === undefined
		) {
			newError.organisation_name = 'Please enter organisation name in the field';
		} else {
			delete newError.organisation_name;
		}
		if (
			!formData.domain ||
			formData.domain === '' ||
			formData.domain === undefined ||
			(formData.domain && newError.domain)
		) {
			newError.domain = newError.domain || 'Please enter organisation domain in the field';
		} else {
			delete newError.domain;
		}

		if (formData.drug_license_number && !validDrugLicenseNumber(formData.drug_license_number)) {
			newError.drug_license_number = 'Please enter valid drug license number';
		} else {
			delete newError.drug_license_number;
		}

		if (formData.gst_settings.gst_registration_enable) {
			if (!formData.gst_settings.gstin || formData.gst_settings.gstin === '') {
				newError.gstin = 'Please enter gstin number in the field';
			} else if (!validateGSTNumber(formData.gst_settings.gstin)) {
				newError.gstin = 'Please enter valid gstin number in the field';
			} else {
				delete newError.gstin;
			}

			if (!formData.gst_settings.business_legal_name || formData.gst_settings.business_legal_name === '') {
				newError.business_legal_name = 'Please enter business legal name in the field';
			} else {
				delete newError.business_legal_name;
			}

			if (!formData.gst_settings.business_trade_name || formData.gst_settings.business_trade_name === '') {
				newError.business_trade_name = 'Please enter business trade name in the field';
			} else {
				delete newError.business_trade_name;
			}

			if (!formData.gst_settings.gst_registration_date || formData.gst_settings.gst_registration_date === '') {
				newError.gst_registration_date = 'Please enter gst registration date in the field';
			} else {
				var date = new Date(formData.gst_settings.gst_registration_date);
				var currentDate = new Date();
				currentDate.setDate(currentDate.getDate() + 1);
				let year = date.getFullYear().toString();
				if (year.length === 4 && new Date(formData.gst_settings.gst_registration_date) > currentDate.setHours(0, 0, 0, 0)) {
					newError.gst_registration_date = 'Date cannot be in the future';
				} else {
					delete newError.gst_registration_date;
				}
			}
		} else {
			delete newError.gstin;
			delete newError.business_legal_name;
			delete newError.business_trade_name;
			delete newError.gst_registration_date;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleOrganizationSave = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error(
				'Something went wrong while update organisation Profile! Please fill required fields.',
			);
		} else {
			try {
				setLoader(true);
				setIsEdit(false);
				var body = {
					organisation_name: formData.organisation_name,
					organisation_logo: formData.organisation_logo || '',
					industry_id: formData?.industry_id,
					sub_domain: formData.domain,
					fiscal_year: formData.fiscal_year,
					language: formData.language,
					time_zone: formData.time_zone,
					date_format: formData.date_format,
					date_separator: formData.date_separator,
					address: formData?.address,
					drug_license_number: formData?.drug_license_number || '',
					gst_registration_enable: formData.gst_settings.gst_registration_enable || false,
					gstin: formData.gst_settings.gstin,
					business_legal_name: formData.gst_settings.business_legal_name,
					business_trade_name: formData.gst_settings.business_trade_name,
					gst_registration_date: formData.gst_settings.gst_registration_date,
					composition_enable: formData.gst_settings.composition_enable || false,
					composition_scheme: formData.gst_settings.composition_scheme || false,
				};
				const res = await updateProfileSettings(body);
				if (res.success === true) {
					localStorage.setItem('suburl', formData.domain);
					toast.success(res.message);
					dispatch(fetchUserInfo());
				} else {
					setIsEdit(true);
					toast.error(res.message || 'Something went wrong');
				}
			} catch (error) {
				setIsEdit(true);
				toast.error(error.message || 'Something went wrong');
			} finally {
				setLoader(false);
			}
		}
	};

	const getStateList = async () => {
		try {
			const { states } = await getStates();
			var statesArray = newObjectCreater(states);
			setStatesList(statesArray);
		} catch (e) {
			toast.error(e.message || 'Something went wrong!');
		}
	};
	const getIndustryList = async () => {
		try {
			const { industries } = await getIndustries();
			var industryArray = newObjectCreater(industries);
			setIndustrieList(industryArray);
		} catch (e) {
			toast.error(e.message || 'Something went wrong!');
		}
	};

	const getDateFormatList = () => {
		try {
			var list = [];
			if (
				formData.date_format !== '' &&
				formData.date_format !== null &&
				formData.date_format !== undefined
			) {
				var value = '';
				if (formData.date_format.includes('/')) {
					value = formData.date_format.replaceAll('/', formData.date_separator);
				}
				if (formData.date_format.includes('-')) {
					value = formData.date_format.replaceAll('-', formData.date_separator);
				}
				if (formData.date_format.includes('.')) {
					value = formData.date_format.replaceAll('.', formData.date_separator);
				}
				handleFormData('date_format', value);
			}

			if (formData.date_separator === '-') {
				list = [
					{ key: 'dd-mm-yy [07-11-2025]', value: 'dd-mm-yy [07-11-25]', type: 'Short' },
					{ key: 'dd-mm-yyyy [07-11-2025]', value: 'dd-mm-yyyy [07-11-2025]', type: 'Medium' },
					{
						key: 'dd-mmmm-yyyy [07-11-2025]',
						value: 'dd-mmmm-yyyy [07 November 2025]',
						type: 'Large',
					},
				];
			} else if (formData.date_separator === '.') {
				list = [
					{ key: 'dd.mm.yy [07.11.2025]', value: 'dd.mm.yy [07.11.25]', type: 'Short' },
					{ key: 'dd.mm.yyyy [07.11.2025]', value: 'dd.mm.yyyy [07.11.2025]', type: 'Medium' },
					{
						key: 'dd.mmmm-yyyy [07.11.2025]',
						value: 'dd.mmmm.yyyy [07 November 2025]',
						type: 'Large',
					},
				];
			} else {
				list = [
					{ key: 'dd/mm/yy [07/11/2025]', value: 'dd/mm/yy [07/11/25]', type: 'Short' },
					{ key: 'dd/mm/yyyy [07/11/2025]', value: 'dd/mm/yyyy [07/11/2025]', type: 'Medium' },
					{
						key: 'dd/mmmm/yyyy [07/11/2025]',
						value: 'dd/mmmm/yyyy [07 November 2025]',
						type: 'Large',
					},
				];
			}

			setDateFormatList(list);
		} catch (e) {
			toast.error(e);
		}
	};

	const getShowUndoChanged = () => {
		const hasProfileChanged = JSON.stringify(organisationProfile) !== JSON.stringify(formData);
		setIsEdit(hasProfileChanged);
	};

	useEffect(() => {
		getShowUndoChanged();
	}, [formData, organisationProfile]);

	useEffect(() => {
		getCity(formData.address.state_id);
	}, [formData.address.state_id]);

	useEffect(() => {
		getStateList();
	}, []);
	useEffect(() => {
		getIndustryList();
	}, []);

	useEffect(() => {
		getOrganizationProfileDetail();
	}, []);

	useEffect(() => {
		getDateFormatList();
	}, [formData.date_separator]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={[
					{
						id: 1,
						disabled: !isEdit || loader,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: loader,
						handler: () => {
							handleOrganizationSave();
						},
					},
					isEdit && {
						id: 1,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changed',
						handler: () => {
							setIsEdit(false);
							getOrganizationProfileDetail();
						},
					},
				].filter((button) => button !== false)}
			/>
			{isLoading ? (
				<PageLoader />
			) : (
				<ProfileForm
					formData={formData}
					primaryContact={primaryContact}
					primaryContactForm={primaryContactForm}
					setPrimaryContactForm={setPrimaryContactForm}
					setFormData={setFormData}
					error={error}
					setError={setError}
					isOpenModal={isOpenModal}
					setIsOpenModal={setIsOpenModal}
					cityList={cityList}
					languageList={languageList}
					fiscalYearList={fiscalYearList}
					dateFormatList={dateFormatList}
					dateSeparatorList={dateSeparatorList}
					timeZoneList={timeZoneList}
					stateList={stateList}
					industryList={industryList}
					handleFormData={handleFormData}
					handleAddressFormData={handleAddressFormData}
					getOrganizationProfileDetail={getOrganizationProfileDetail}
					handleGSTFormData={handleGSTFormData}
				/>
			)}
		</div>
	);
}
